import { BookingSystem } from '../../../apis/types';
import { ToolName } from '../apis/types';

/** Maps a booking system to the corresponding API tool name. */
export const bookingSystemToToolName = (
  bookingSystem: BookingSystem
): ToolName => {
  const mapping: Record<BookingSystem, ToolName> = {
    lexoffice: 'lex_office',
    datev: 'klardaten',
  };
  return mapping[bookingSystem];
};

/** Returns a user-friendly display name for a booking system. */
export const getBookingSystemDisplayName = (
  bookingSystem: BookingSystem
): string => {
  const displayNames: Record<BookingSystem, string> = {
    datev: 'DATEV',
    lexoffice: 'Lexware Office',
  };
  return displayNames[bookingSystem];
};
